module.exports = __webpack_public_path__ + "img/L.1fc90ca7.png";